/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssetOwners } from '../models/AssetOwners';
import type { RoutesAssetOwnedByResponse } from '../models/RoutesAssetOwnedByResponse';
import type { RoutesAssetTransfersResponse } from '../models/RoutesAssetTransfersResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class OwnershipAndTransferDataService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get assets owned by an address
     * Returns all assets owned by a particular account address
     * @returns RoutesAssetOwnedByResponse OK
     * @throws ApiError
     */
    public getAssetsOwnedByAccount({
        address = 'vitalik.eth',
        network = 'ethereum-mainnet',
        collection,
        excludeCollection,
        limit,
        offset,
    }: {
        /** Owner's Account Address **/
        address?: string,
        /** Network ID **/
        network?: 'arbitrum-mainnet' | 'avalanche-mainnet' | 'bsc-mainnet' | 'celo-mainnet' | 'ethereum-goerli' | 'ethereum-mainnet' | 'ethereum-rinkeby' | 'ethereum-ropsten' | 'fantom-mainnet' | 'harmony-mainnet' | 'optimism-mainnet' | 'polygon-mainnet' | 'solana-mainnet',
        /** Optional collection address (or comma-separated list of collection addresses) **/
        collection?: string | null,
        /** Optional collection address (or comma-separated list of collection addresses) **/
        excludeCollection?: string | null,
        limit?: number | null,
        offset?: number | null,
    }): CancelablePromise<RoutesAssetOwnedByResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/{network}/account/{address}/assets-owned',
            path: {
                'address': address,
                'network': network,
            },
            query: {
                'collection': collection,
                'excludeCollection': excludeCollection,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Validation Error`,
                403: `Access not enabled`,
            },
        });
    }

    /**
     * Get asset transfers
     * Returns transfers for a particular asset
     * @returns RoutesAssetTransfersResponse OK
     * @throws ApiError
     */
    public getTransfersOfAsset({
        network = 'ethereum-mainnet',
        collection = '0xBC4CA0EdA7647A8aB7C2061c2E118A18a936f13D',
        fromAddress,
        limit,
        offset,
        toAddress,
        tokenId = '1',
    }: {
        /** Network ID **/
        network?: 'arbitrum-mainnet' | 'avalanche-mainnet' | 'bsc-mainnet' | 'celo-mainnet' | 'ethereum-goerli' | 'ethereum-mainnet' | 'ethereum-rinkeby' | 'ethereum-ropsten' | 'fantom-mainnet' | 'harmony-mainnet' | 'optimism-mainnet' | 'polygon-mainnet' | 'solana-mainnet',
        /** collection address (or comma-separated list of collection addresses) **/
        collection?: string,
        /** Optional 'from' Address **/
        fromAddress?: string | null,
        limit?: number | null,
        offset?: number | null,
        /** Optional 'to' Address **/
        toAddress?: string | null,
        /** Token ID **/
        tokenId?: string,
    }): CancelablePromise<RoutesAssetTransfersResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/{network}/transfers',
            path: {
                'network': network,
            },
            query: {
                'collection': collection,
                'fromAddress': fromAddress,
                'limit': limit,
                'offset': offset,
                'toAddress': toAddress,
                'tokenID': tokenId,
            },
            errors: {
                400: `Validation Error`,
            },
        });
    }

    /**
     * Get owners of a collection
     * Returns owners who own an asset in given collection
     * @returns AssetOwners OK
     * @throws ApiError
     */
    public getAssetOwners({
        address = '0xBC4CA0EdA7647A8aB7C2061c2E118A18a936f13D',
        network = 'ethereum-mainnet',
        limit,
        offset,
        owner,
    }: {
        /** Collection Address **/
        address?: string,
        /** Network ID **/
        network?: 'arbitrum-mainnet' | 'avalanche-mainnet' | 'bsc-mainnet' | 'celo-mainnet' | 'ethereum-goerli' | 'ethereum-mainnet' | 'ethereum-rinkeby' | 'ethereum-ropsten' | 'fantom-mainnet' | 'harmony-mainnet' | 'optimism-mainnet' | 'polygon-mainnet' | 'solana-mainnet',
        limit?: number | null,
        offset?: number | null,
        /** Optional owner/holder address to filter assets **/
        owner?: string | null,
    }): CancelablePromise<AssetOwners> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/{network}/{address}/asset-owners',
            path: {
                'address': address,
                'network': network,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'owner': owner,
            },
            errors: {
                400: `Validation Error`,
            },
        });
    }

}